var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',_vm._l((_vm.props.benefitsName),function(benefitName,index){return _c('CompareCell',{key:index,attrs:{"label":benefitName.name,"data":_vm.isBenefitInclude(benefitName.id),"isbenefit":true}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }